import type { Fieldset } from "@/static/types";

import { hideLoader, showLoader } from "@/helpers/loader";
import { translate } from "@/locale/translate";
import { sendForm as mailchimp } from "./providers/mailchimp";
import { sendIndividualForm as optima } from "./providers/optima";
import { assertEmptyFields } from "@/helpers/assertEmptyFields";

export const submitPartnerForm = (form: HTMLFormElement) => {
  const lang = form.lang || "ru";
  const id = form.getAttribute("id");
  const toggleFormState = async () => {
    if (!form) return;
    showLoader(form);
    try {
      await mailchimp(new FormData(form));
      const optimRes = await optima({
        name: fieldset.fullname.value,
        email: fieldset.email.value,
        organization: fieldset.companyName.value,
        phone: fieldset.phone.value,
      });
      if (optimRes.status === 200) {
        const formData = new FormData(form);
        formData.append("MERGE11", "Yes");
        await mailchimp(formData);
      }
      // hide feedback form and show success message
      const successMessageElement = document.querySelector(
        `div[data-modal-success-message="${id}"]`,
      );
      form?.classList.add("!hidden");
      successMessageElement?.classList.add("!flex");
    } catch (err) {
      console.log("Error when sending partner form:", err);
    } finally {
      hideLoader(form);
    }
  };

  // text fields from DOM
  const fieldset: Fieldset<HTMLInputElement>["individual"] = {
    fullname: document.getElementById("MERGE1-" + id) as HTMLInputElement,
    phone: document.getElementById("MERGE2-" + id) as HTMLInputElement,
    companyName: document.getElementById("MERGE3-" + id) as HTMLInputElement,
    email: document.getElementById("MERGE0-" + id) as HTMLInputElement,
  };
  const errors: Fieldset<string>["individual"] = {
    fullname: "",
    phone: "",
    companyName: "",
    email: "",
  };

  // regex to test an email
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;

  assertEmptyFields("individual", fieldset, errors, lang);
  if (fieldset.email.value && !emailRegex.test(fieldset.email.value)) {
    errors.email = translate("Некорректный адрес email", lang);
  }
  for (const el in errors) {
    const key = el as keyof typeof fieldset;
    if (fieldset[key]?.nextElementSibling?.tagName.toLowerCase() === "span")
      fieldset[key]!.nextElementSibling!.innerHTML = errors[key];
  }
  if (!Object.values(errors).some((el) => el)) {
    toggleFormState();
  }
};
